
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive_post/[single_post]",
      function () {
        return require("private-next-pages/archive_post/[single_post].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive_post/[single_post]"])
      });
    }
  